import React, { useState, useEffect } from 'react';

const useBubbles = (totalBubble) => {
	const [bubbles, setBubbles] = useState([]);

	useEffect(() => {
		const total = totalBubble || 25;
		let newBubbles = [];
		for (let i = 0; i < total; i++) {
			newBubbles.push({
				key: i,
				diameter: Math.random() * 80 + 10,
				opacity: Math.random() * 0.4 + 0.2,
				left: Math.random() * 100,
				top: Math.random() * 100,
				duration: Math.random() * 15 + 10, // 10s–25s
				delay: Math.random() * 10
			});
		}
		setBubbles(newBubbles);
	}, [totalBubble]);

	return bubbles.map((bubble) => (
		<div
			key={bubble.key}
			className='bubble'
			style={{
				top: `${bubble.top}%`,
				left: `${bubble.left}%`,
				width: bubble.diameter,
				height: bubble.diameter,
				opacity: bubble.opacity,
				position: 'absolute',
				animation: `floatUp ${bubble.duration}s ease-in-out infinite`,
				animationDelay: `${bubble.delay}s`
			}}
		/>
	));
};

export default useBubbles;
